'use strict';

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('winresReservationPopupContent', [function () {
    return {
        restrict: 'E', //Element-only usage
        link: function link($scope, $element, $attrs, controller, $transclude) {
            $element.empty();
            $element.append($scope.content);
        },
        scope: {
            content: '='
        }
    };
}]); // Directive which transcludes given parameter into its contents.


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationPopup/winresReservationPopupContent.js
// module id = 273
// module chunks = 2